/**
 * Dynamic imports shared between lazy components and early warm-ups, so both hit the same
 * module and the download happens once.
 *
 * @module
 */

/** The WebGL renderer behind every `<SceneCanvas>` (it pulls in three.js and R3F). */
export const loadSceneRenderer = () => import('./SceneRenderer')
